<template>
	<div v-katex:auto>
		<publicHeader @child-event="myInfoEvent"></publicHeader>
		<studyHeader :subjectIndex="subjectIndex" :studyNav="studyNav" :myInfo="myInfo" :public="public"></studyHeader>
		<div class="practice bg_gray practice_second">
			<div class="my_position flex">
				<div class="my_position_l cl_gray">
					<img src="../../../static/icon_position.png" class="mar5" />
					<p>当前位置：<router-link to="/" class="cl_gray">首页</router-link>  >  <router-link to="/study" class="cl_gray">趣学习</router-link>
						>  {{data.paperName}}</p>
				</div>
				<div class="my_position_r cl_violet" @click="$router.go(-1)"><span class="mar5">返回上级</span><img src="../../../static/return_violet.png" /></div>
			</div>
			<div class="w1200 flex practice_test report">
				<div class="practice_l bg_white radius8">
					<div class="report_header f20px cl_white">
						<div class="report_header_list">
							<div class="report_header_list_l">正确率：</div>
							<div class="report_header_list_r">{{data.probability}}</div>
						</div>
						<div class="report_header_list mat10">
							<div class="report_header_list_l">用时：</div>
							<div class="report_header_list_r">{{data.time}}</div>
						</div>
					</div>
					<div class="practice_l_title f26px cl_dark">
						<p>{{data.paperName}}</p>
					</div>
					<div class="practice_l_cont mat30">
						<div class="question_list" v-for="(item,index) in data.paperques" :id="item.id">
							<div class="question_list_l f18px">{{index + 1}}、</div>
							<div class="choice_div" v-if="item.qtpye == '单选题' || item.qtpye == '多选题' || item.qtpye == '双选题' || item.qtpye == '选择题'">
								<div class="choice_title f18px" v-html="item.title"></div>
								<div class="choice_div_cont mat15 f16px cl_gray">
									<div class="choice_list radius8 flex" :class="[{'correct':item.option_a_ture},{'on':item.answer1=='A'}]" v-if="item.option_a != ''">
										<div class="choice_list_l">A</div>
										<div class="choice_list_r" v-html="item.option_a"></div>
									</div>
									<div class="choice_list radius8 flex" :class="[{'correct':item.option_b_ture},{'on':item.answer1=='B'}]" v-if="item.option_b != ''">
										<div class="choice_list_l">B</div>
										<div class="choice_list_r" v-html="item.option_b"></div>
									</div>
									<div class="choice_list radius8 flex" :class="[{'correct':item.option_c_ture},{'on':item.answer1=='C'}]" v-if="item.option_c != ''">
										<div class="choice_list_l">C</div>
										<div class="choice_list_r" v-html="item.option_c"></div>
									</div>
									<div class="choice_list radius8 flex" :class="[{'correct':item.option_d_ture},{'on':item.answer1=='D'}]" v-if="item.option_d != ''">
										<div class="choice_list_l">D</div>
										<div class="choice_list_r" v-html="item.option_d"></div>
									</div>
									<div class="choice_list radius8 flex" :class="[{'correct':item.option_e_ture},{'on':item.answer1=='E'}]" v-if="item.option_e != ''">
										<div class="choice_list_l">E</div>
										<div class="choice_list_r" v-html="item.option_e"></div>
									</div>
								</div>
								<div class="report_list_btm mat20" v-if="['单选题','选择题'].indexOf(item.qtpye) < 0">
									<div class="report_list_btm_l f16px cl_dark">你的校对结果：
										<span class="cl_green" v-if="item.correct == 1">正确</span>
										<span class="cl_yel" v-if="item.correct == 0.5">半对</span>
										<span class="cl_red" v-if="item.correct == 0">错误</span>
									</div>
									<div class="report_list_btn tc cl_white cur"@click="proofBtn(index)">解析</div>
								</div>
								<div class="report_list_btm mat20" v-else>
									<div class="report_list_btm_l f16px cl_dark">正确答案：<span class="cl_green">{{item.answer1}}</span> , 你的答案：<span class="cl_red">{{item.my_answer}}</span></div>
									<div class="report_list_btn tc cl_white cur" @click="proofBtn(index)">解析</div>
								</div>
							</div>
							<div class="other_div" v-else>
								<div class="choice_title f18px" v-html="item.title"></div>
								<div class="other_second cl_gray" v-if="item.isSub == 1">
									<div class="other_second_list mat20" v-for="(second,index) in item.subquestions" :key="index" :id="second.id">
										<div class="other_second_list_l f18px">{{index + 1}}、</div>
										<div class="other_second_list_r f18px" v-html="second.title"></div>
									</div>
								</div>
								<div class="report_list_btm mat20">
									<div class="report_list_btm_l f16px cl_dark">你的校对结果：
										<span class="cl_green" v-if="item.correct == 1">正确</span>
										<span class="cl_yel" v-if="item.correct == 0.5">半对</span>
										<span class="cl_red" v-if="item.correct == 0">错误</span>
									</div>
									<div class="report_list_btn tc cl_white cur"@click="proofBtn(index)">解析</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="practice_r bg_white radius8">
					<div class="practice_r_title">
						<img src="../../../static/report_icon.png" class="mar5" />
						<div class="practice_r_time f20px">
							<span class="cl_dark">答题详情</span>
						</div>
					</div>
					<div class="report_index_cont mat10">
						<div class="report_wrong">
							<div class="cl_gray">错题</div>
							<div class="report_index_div mat10">
								<div class="question_index" v-for="(item,index) in data.paperques" :key="index">
									<div class="question_index_title bg_gray radius cl_white" v-if="item.correct != 1" @click="toIndex(item.id)" :class="{'on':item.correct == 0.5}">{{index+1}}</div>
								</div>
							</div>
						</div>
						<div class="report_correct">
							<div class="cl_gray">对题</div>
							<div class="report_index_div mat10">
								<div class="question_index" v-for="(item,index) in data.paperques" :key="index">
									<div class="question_index_title bg_gray radius cl_white" v-if="item.correct == 1" @click="toIndex(item.id)">{{index+1}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<vfooter @child-event="publicEvent"></vfooter>
		<!-- 解析 -->
		<div class="bg" v-if="proofShow == true" @click="proofClose"></div>
		<div class="proof proof_second bg_white radius8 bs" :class="{'on':proofShow}">
			<div class="proof_close">
				<img src="../../../static/close_violet.png" class="cur" @click="proofClose" />
			</div>
			<div class="proof_title f22px tc">习题解析</div>
			<div class="proof_div mat20">
				<div class="proof_subject">
					<div class="proof_subject_title f16px" v-html="proofPaper.title"></div>
					<div class="proof_subject_cont cl_gray mat20" v-if="proofPaper.subquestions">
						<div class="proof_subject_list mat5" v-for="(item,index) in proofPaper.subquestions" :key="index" v-html="item.title"></div>
					</div>
					<div class="proof_subject_check mat20" v-if="proofPaper.option_a != ''">
						<div class="proof_subject_check_list mat5" v-if="proofPaper.option_a != ''">
							<div class="proof_subject_check_list_l">A.</div>
							<div class="proof_subject_check_list_r" v-html="proofPaper.option_a"></div>
						</div>
						<div class="proof_subject_check_list mat5" v-if="proofPaper.option_b != ''">
							<div class="proof_subject_check_list_l">B.</div>
							<div class="proof_subject_check_list_r" v-html="proofPaper.option_b"></div>
						</div>
						<div class="proof_subject_check_list mat5" v-if="proofPaper.option_c != ''">
							<div class="proof_subject_check_list_l">C.</div>
							<div class="proof_subject_check_list_r" v-html="proofPaper.option_c"></div>
						</div>
						<div class="proof_subject_check_list mat5" v-if="proofPaper.option_d != ''">
							<div class="proof_subject_check_list_l">D.</div>
							<div class="proof_subject_check_list_r" v-html="proofPaper.option_d"></div>
						</div>
						<div class="proof_subject_check_list mat5" v-if="proofPaper.option_e != ''">
							<div class="proof_subject_check_list_l">E.</div>
							<div class="proof_subject_check_list_r" v-html="proofPaper.option_e"></div>
						</div>
					</div>
				</div>
				<div class="proof_analysis mat20">
					<div class="proof_analysis_l f18px">解析：</div>
					<div class="proof_analysis_r" v-html="proofPaper.parse"></div>
				</div>
			</div>
			<div class="mat20 proof_btm_close tc">
				<span class="inline f18px cl_violet cur" @click="proofClose">关闭</span>
			</div>
		</div>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import studyHeader from '../../components/study_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'report',
		components: {
			publicHeader,
			studyHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				subjectIndex: false, //学科分类显示
				studyNav: -1, //导航
				myInfo: {},
				public: {},
				data: {}, //试卷
				proofShow: false, //解析显示
				proofPaper: {}, //解析选中题目
			}
		},
		created() {
			if (localStorage.getItem("paper")) {
				this.data = JSON.parse(localStorage.getItem("paper"))
			}
		},
		destroyed () {
			
		},
		mounted() {
			
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//索引跳转
			toIndex (e) {
				document.getElementById(e).scrollIntoView();
			},
			//解析
			proofBtn (e) {
				var that = this;
				that.proofPaper = that.data.paperques[e];
				setTimeout(() => {
					that.proofShow = true;
				}, 0);
			},
			proofClose () {
				this.proofShow = false;
			},
			
		},
	}
</script>

<style>
</style>
